export type UserType = {
  fullName: string;
};

export enum Sizes {
  SM = "sm",
  MD = "md",
}

export enum PixelSizes {
  sm = 24,
  md = 40,
}

export const AVATAR_BACKGROUND_COLORS = [
  "#AB2328",
  "#DD5350",
  "#814D59",
  "#0093D1",
  "#4871AA",
  "#0083A1",
  "#555555",
  "#268752",
  "#7B61FF",
  "#7252AC",
];
